import React from 'react';
import { Card, CardContent } from './ui/card';
import { TrendingUp, AlertTriangle, CheckCircle, Clock, Target } from 'lucide-react';

export default function StatsPanel({ stats }) {
  const totalTasks = stats?.total_tasks || 0;
  const byStatus = stats?.by_status || {};

  const openTasks = Object.entries(byStatus).reduce((sum, [key, count]) => {
    if (key && (key.includes('pendiente') || key.includes('abierta') || key === 'null' || !key)) {
      return sum + count;
    }
    return sum;
  }, 0);

  const inProgressTasks = Object.entries(byStatus).reduce((sum, [key, count]) => {
    if (key && (key.includes('en_ejecucion') || key.includes('en_progreso') || key.includes('en_reparacion'))) {
      return sum + count;
    }
    return sum;
  }, 0);

  const completedTasks = Object.entries(byStatus).reduce((sum, [key, count]) => {
    if (key && (key.includes('finalizada') || key.includes('completada') || key.includes('resuelta') || key.includes('cerrada'))) {
      return sum + count;
    }
    return sum;
  }, 0);

  const resolutionRate = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;

  const statCards = [
    {
      title: 'Total Incidencias',
      value: totalTasks.toLocaleString('es-ES'),
      icon: TrendingUp,
      color: 'text-blue-600',
      bg: 'bg-blue-50 dark:bg-blue-950/30',
      border: 'border-blue-100 dark:border-blue-900/30',
    },
    {
      title: 'Pendientes/Abiertas',
      value: openTasks.toLocaleString('es-ES'),
      icon: AlertTriangle,
      color: 'text-red-600',
      bg: 'bg-red-50 dark:bg-red-950/30',
      border: 'border-red-100 dark:border-red-900/30',
    },
    {
      title: 'En Progreso',
      value: inProgressTasks.toLocaleString('es-ES'),
      icon: Clock,
      color: 'text-orange-600',
      bg: 'bg-orange-50 dark:bg-orange-950/30',
      border: 'border-orange-100 dark:border-orange-900/30',
    },
    {
      title: 'Completadas',
      value: completedTasks.toLocaleString('es-ES'),
      icon: CheckCircle,
      color: 'text-green-600',
      bg: 'bg-green-50 dark:bg-green-950/30',
      border: 'border-green-100 dark:border-green-900/30',
    },
    {
      title: 'Tasa de Resolución',
      value: `${resolutionRate}%`,
      icon: Target,
      color: resolutionRate >= 70 ? 'text-green-600' : resolutionRate >= 40 ? 'text-orange-600' : 'text-red-600',
      bg: resolutionRate >= 70 ? 'bg-green-50 dark:bg-green-950/30' : resolutionRate >= 40 ? 'bg-orange-50 dark:bg-orange-950/30' : 'bg-red-50 dark:bg-red-950/30',
      border: 'border-green-100 dark:border-green-900/30',
      sub: `${completedTasks} de ${totalTasks}`,
    },
  ];

  return (
    <div className="px-6 py-3 bg-white dark:bg-gray-900 border-b border-border">
      <div className="grid grid-cols-5 gap-3">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <Card key={stat.title} className={`overflow-hidden border ${stat.border}`}>
              <CardContent className="p-3">
                <div className="flex items-center justify-between">
                  <div className="min-w-0">
                    <p className="text-xs text-muted-foreground truncate">{stat.title}</p>
                    <p className="text-xl font-bold mt-0.5">{stat.value}</p>
                    {stat.sub && <p className="text-[10px] text-muted-foreground mt-0.5">{stat.sub}</p>}
                  </div>
                  <div className={`p-2 rounded-lg ${stat.bg} flex-shrink-0`}>
                    <Icon className={`w-5 h-5 ${stat.color}`} />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
